// 工序类型
export const processTypeObj = {
  MATERIAL_DYEING: '材料染色',
  CLOTH: '坯布工序',
  CLOTH_DYEING: '坯布染色',
  SEWING: '缝制工序',
  PACKING: '包装工序',
};
export const processTypeSet = {
  CLOTH: '1', // 坯布
  DYEING: '2', // 染色
  // PROCUREMENT: '3', // 采购
  SEWING: '4', // 缝制
  PACKING: '5', // 包装
};
export const processTypeOptions = [
  { dictValue: processTypeSet.CLOTH, dictLabel: '坯布工序' },
  { dictValue: processTypeSet.DYEING, dictLabel: '染色工序' },
  // { dictValue: processTypeSet.PROCUREMENT, dictLabel: '采购工序' },
  { dictValue: processTypeSet.SEWING, dictLabel: '缝制工序' },
  { dictValue: processTypeSet.PACKING, dictLabel: '包装工序' },
];

// 计件方式
export const RECORD_TYPE = {
  HOURLY: 'HOURLY_WAGE', // 计时
  PIECE_RATE: 'PIECE_RATE_WAGE', // 计件
};
export const RECORD_PRICE_OPTIONS = [
  { dictValue: RECORD_TYPE.HOURLY, dictLabel: '计时' },
  { dictValue: RECORD_TYPE.PIECE_RATE, dictLabel: '计件' },
];

// 入菲模式
export const enterFiModeSet = {
  SCHEDULE: 'SCHEDULE', // 排期入菲
  FREEDOM: 'FREEDOM', // 自由入菲
};

// 员工类型
export const JOB_TYPE = {
  NORMAL: 1,
  TEMP: 2,
};
export const JOB_TYPE_OPTIONS = [
  { dictValue: JOB_TYPE.NORMAL, dictLabel: '正式工' },
  { dictValue: JOB_TYPE.TEMP, dictLabel: '临时工' },
];

// 员工在职状态
export const JOB_STATUS = {
  ON: '1',
  OFF: '0',
};

// 生产单生产状态
export const projectStatusTypeObj = { NOT_FINISH: 0, FINISHED: 1, DOING: 2 };
export const projectStatusOptions = [
  { dictValue: projectStatusTypeObj.NOT_FINISH, dictLabel: '未完成' },
  { dictValue: projectStatusTypeObj.DOING, dictLabel: '进行中' },
  { dictValue: projectStatusTypeObj.FINISHED, dictLabel: '已完成' },
];

// 人员职级RUSTY=新手，SKILLED=熟手，CAPABLE=能手
export const proficiencyOptions = [
  { dictValue: 'RUSTY', dictLabel: '新手' },
  { dictValue: 'SKILLED', dictLabel: '熟手' },
  { dictValue: 'CAPABLE', dictLabel: '能手' },
];
export const proficiencySet = { RUSTY: 'RUSTY', SKILLED: 'SKILLED', CAPABLE: 'CAPABLE' };

// 员工班次
export const classifyTextOptions = [
  { dictValue: '1/1', dictLabel: '早班', order: 1 },
  { dictValue: '1/2', dictLabel: '早班', order: 2 },
  { dictValue: '2/2', dictLabel: '晚班', order: 3 },
  { dictValue: '1/3', dictLabel: '早班', order: 4 },
  { dictValue: '2/3', dictLabel: '中班', order: 5 },
  { dictValue: '3/3', dictLabel: '晚班', order: 6 },
];
